import React, { Component } from "react";
import Popover from "material-ui/Popover";
import * as colors from "../constants/colors";
import * as globalStyles from "../constants/styles";

export default class Position extends Component {
  render() {
    const { anchor, open, onClose, info } = this.props;
    const { fullName, phone, mobilePhone, email } = info || {};
    return (
      <Popover
        open={open}
        anchorEl={anchor}
        anchorOrigin={{ horizontal: "middle", vertical: "bottom" }}
        targetOrigin={{ horizontal: "middle", vertical: "top" }}
        onRequestClose={onClose}
        style={styles.container}
      >
        {!!fullName && (
          <div style={styles.row}>
            <div style={styles.key}>Namn</div>
            <div style={styles.value}>{fullName}</div>
          </div>
        )}
        {!!phone && (
          <div style={styles.row}>
            <div style={styles.key}>Telefon</div>
            <div style={styles.value}>{phone}</div>
          </div>
        )}
        {!!mobilePhone && (
          <div style={styles.row}>
            <div style={styles.key}>Mobile</div>
            <div style={styles.value}>{mobilePhone}</div>
          </div>
        )}
        {!!email && (
          <div style={styles.row}>
            <div style={styles.key}>E-post</div>
            <div style={styles.value}>{email}</div>
          </div>
        )}
      </Popover>
    );
  }
}

const styles = {
  container: {
    width: 400,
    marginLeft: globalStyles.space,
    marginTop: -globalStyles.space,
    padding: globalStyles.space,
    background:
      "linear-gradient(to right bottom, " +
      colors.white +
      ", " +
      colors.grey +
      ")"
  },
  row: {
    display: "flex",
    marginTop: globalStyles.space,
    marginBottom: globalStyles.space
  },
  key: {
    flex: 1,
    flexShrink: 1
  },
  value: {
    flex: 2,
    fontWeight: 700
  }
};



// WEBPACK FOOTER //
// ./src/components/InfoBox.js